import { environment } from '@env/environment';
import { ApiError } from './api-error';

export class HttpApiError {
    title: string = 'Error';
    text: string = '';
    url: string | null = null;
    method: string | null = null;
    body: any = null;
    guid: string | null = null;
    status: number = 0;
    statusText: string = '';
    error?: ApiError;
    debug?: boolean = environment.env != 'prod';
    type?: string;
    _canBeCleared?: boolean;
    _dt!: string;

    constructor(title: string, text?: string, status?: number, etype?: string) {
        this._dt = new Date().toISOString();
        if (title != null) {
            this.title = title;
        }
        if (text != null) {
            this.text = text;
        }
        if (status) {
            this.status = status;
        }
        if (etype) {
            this.type = etype;
        }
    }

    cbc(): HttpApiError {
        this._canBeCleared = true;
        return this;
    }

}
